import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit
} from '@angular/core';
import { PopoverService } from '../../../components/popover/popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { StaffService } from '../../../../app/services/staff/staff.service';
import { User } from '../../../../app/models/user/user.model';
import { Subscription } from 'rxjs';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  styleUrls: ['./toolbar-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserComponent implements OnInit, OnDestroy {
  dropdownOpen: boolean;
  userDetail: User;
  userDetailsSub: Subscription;
  private activePopoverRef: PopoverRef<User> | null = null;
  private popoverClosedSub: Subscription | null = null;

  constructor(
    private popover: PopoverService,
    private cd: ChangeDetectorRef,
    public authService: AuthService,
    private staffService: StaffService
  ) {}

  ngOnInit() {
    this.getUserData();
    this.getUserDetails();
  }

  getUserData() {
    this.staffService
      .find(this.authService.getCurrentUserId())
      .subscribe(response => {
        this.staffService.userDetails$.next(response.body);
      });
  }

  getUserDetails() {
    this.userDetailsSub = this.staffService.userDetails$.subscribe(response => {
      this.userDetail = response;
      this.cd.detectChanges();
    });
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    this.activePopoverRef = this.popover.open({
      data: this.userDetail,
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    this.popoverClosedSub = this.activePopoverRef.afterClosed$.subscribe(() => {
      this.activePopoverRef = null;
      this.popoverClosedSub = null;
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }

  ngOnDestroy() {
    if (this.userDetailsSub) {
      this.userDetailsSub.unsubscribe();
    }
    if (this.popoverClosedSub) {
      this.popoverClosedSub.unsubscribe();
    }
    if (this.activePopoverRef) {
      this.activePopoverRef.close();
    }
  }
}
